import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import SEOHead from "@/components/seo/SEOHead";
import SchemaMarkup from "@/components/seo/SchemaMarkup";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <SEOHead
        title="Privacy Policy | Web Host Buy BD Data Protection &amp; Security"
        description="Web Host Buy BD Privacy Policy - learn how we collect, use &amp; protect your personal information. Your privacy and data security are our top priority as Bangladesh's trusted BDIX hosting provider."
        canonical="/privacy-policy"
        keywords="Web Host Buy BD, bdix hosting, web hosting Bangladesh"
      />
      <SchemaMarkup
        type="page"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Privacy Policy", url: "/privacy-policy" },
        ]}
        pageName="Privacy Policy - Web Host Buy BD"
        pageDescription="Web Host Buy BD's privacy policy and data protection practices for BDIX hosting services"
      />
      <PageHero
        title="Privacy Policy"
        subtitle="Last updated: January 1, 2026"
      />

      <section className="py-20 bg-background">
        <div className="container-custom max-w-4xl">
          <article className="prose prose-lg max-w-none">
            <div className="space-y-8 text-foreground">
              <section>
                <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Web Host Buy BD ("we," "our," or "us") is committed to protecting your privacy. 
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your 
                  information when you visit our website or use our BDIX hosting services in Bangladesh.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">2. Information We Collect</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We collect information you provide directly to us, such as:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Name, email address, and contact information</li>
                  <li>Billing and payment information</li>
                  <li>Account credentials</li>
                  <li>Communication preferences</li>
                  <li>Support tickets and correspondence</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">3. How We Use Your Information</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Provide, maintain, and improve our BDIX hosting services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Protect against fraudulent or illegal activity</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">4. Data Security</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We implement appropriate technical and organizational measures to protect 
                  your personal information against unauthorized access, alteration, disclosure, 
                  or destruction. This includes encryption, firewalls, and secure server facilities 
                  in our Bangladesh datacenters.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">5. Data Retention</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We retain your personal information for as long as necessary to provide our 
                  BDIX hosting services and fulfill the purposes described in this policy. When we no longer 
                  need your information, we will securely delete or anonymize it.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">6. Your Rights</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Access and receive a copy of your personal data</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request restriction of processing</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">7. Contact Us</h2>
                <p className="text-muted-foreground leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact Web Host Buy BD at:
                  <br /><br />
                  <strong>Email:</strong> hello@webhostbuybd.com<br />
                  <strong>Phone:</strong> +880 9649 660000<br />
                  <strong>Address:</strong> 10 Nur Vobon (2nd Floor), Nogor Vobon Road, Manikganj
                </p>
              </section>
            </div>
          </article>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;